import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IChatArriveMessageIrdx } from "@interfaces/redux/base-state";
export const chatNewMessageFlag = createSlice({
    name: "chatNewMessageFlag",
    initialState: {
        arriveMessage:true,
    } as IChatArriveMessageIrdx,
    reducers: {
        /**
         * @param current state
         * @param action payload with new data to update state
         */
        setChatNewMessageFlag: (state, action: PayloadAction<IChatArriveMessageIrdx>) => {
            state.arriveMessage = action.payload.arriveMessage;
        },
        // user log out
        setChatNewMessageFlagClean: (state) => {
            state.arriveMessage =false;
        },
    },
});
export const { setChatNewMessageFlag, setChatNewMessageFlagClean } = chatNewMessageFlag.actions;
export default chatNewMessageFlag.reducer;
